import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-contact_method_99",
  "use": "icon-contact_method_99-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-contact_method_99\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 0C1.34315 0 0 1.34315 0 3V14C0 15.6569 1.34315 17 3 17H14C15.6569 17 17 15.6569 17 14V3C17 1.34315 15.6569 0 14 0H3ZM13 10C13.5523 10 14 9.55229 14 9C14 8.44771 13.5523 8 13 8C12.4477 8 12 8.44771 12 9C12 9.55229 12.4477 10 13 10ZM10 9C10 9.55229 9.55229 10 9 10C8.44771 10 8 9.55229 8 9C8 8.44771 8.44771 8 9 8C9.55229 8 10 8.44771 10 9ZM5 10C5.55228 10 6 9.55229 6 9C6 8.44771 5.55228 8 5 8C4.44772 8 4 8.44771 4 9C4 9.55229 4.44772 10 5 10Z\" fill=\"#314455\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/contact_method_99.svg
// module id = efSn
// module chunks = 262